var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderStock',{attrs:{"header":"จัดการข้อมูลวัตถุดิบ","img_header":_vm.header_image,"link_back":"stock"}}),_c('StockMaterialList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }